import { addPrecondition, Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, SalesOrderDTO, SaleDTO, Res } from 'core/api';
import { showCloseDocumentScreen } from 'pos/modules/helpers/document-creation';
import * as SalesOrderStore from './SalesOrderStore';
import { Message } from 'core/ui-next/modal';


declare global {
	interface CommandType {
		closeSalesOrder: (order: SalesOrderDTO) => Promise<Result<SaleDTO>>
	}
}



const createInvoice = addPrecondition(
	Preconditions.ensure(Permission.Ticket_Close),
	async function (order: SalesOrderDTO) {
		return await showCloseDocumentScreen({
			layout: 'CloseSalesOrder',
			getDocument: () => {
				return {
					ticketIds: [order.TicketId],
					ticketGlobalId: order.TicketGlobalId,
					pendingAmount: order.PendingAmount,
					customer: order.Customer
				};
			},
			setCustomer: async _ => { },
			closeDocument: params => SalesOrderStore.createInvoice(order.Id, params)

		});
	});

const createRefund = addPrecondition(
	// OJO: Este permiso es el que se usaba en el PC. No hay permisos específicos
	// para emitir devoluciones desde albaranes o desde pedidos, siempre se usa Ticket_Refund
	Preconditions.ensure(Permission.Ticket_Refund),
	async function (order: SalesOrderDTO) {

		return await showCloseDocumentScreen({
			layout: 'CreateRefund',
			getDocument: () => {
				return {
					ticketIds: [order.TicketId],
					ticketGlobalId: order.TicketGlobalId,
					pendingAmount: -1 * order.PendingAmount,
					customer: order.Customer
				};
			},
			setCustomer: async _ => { },
			closeDocument: params => SalesOrderStore.createRefund(order.Id, params)

		});
	});
// Al igual que en createInvoiceOrRefundDeliveryNotesCommand.tsx, no lleva permiso porque internamente distingue entre invoice o refund para
// aplicar el permiso necesario. 
Command.register('closeSalesOrder', Preconditions.ensureIsNotLite, async (order: SalesOrderDTO): Promise<Result<SaleDTO>> => {

	// TODO: Hay que tratar de poner lotes a las líneas del pedido que lo requieran.
	// Cuando hagamos esto ver si lo estamos haciendo a la hora de vender o añadir una línea

	const isRefund = order.NetAmount < 0;

	if (isRefund && !(await Message.confirm(Res.Msg.MSG_EMIT_REFUND())).ok)
		return Result.error();

	return isRefund ? createRefund(order) : createInvoice(order);
});